import { Menu, MenuItem } from "@mui/material";
import { DeleteOutline, EditOutlined } from "@mui/icons-material";
import useAuth from "../../hoc/AuthProvider/useAuth";
import { Permissions } from "../../config/permissions";
import { DeviceDto } from "../../types";

type DeviceMenuProps = {
  anchorEl: null | HTMLElement;
  onClose: () => void;
  onView: () => void;
  onDelete?: () => void;
  device?: DeviceDto;
};

const DeviceMenu: React.FC<DeviceMenuProps> = ({ anchorEl, onClose, onView, onDelete, device }) => {
  const { havePermission } = useAuth();

  const inGroup = !!device?.deviceGroupId;

  const canEdit   = havePermission(Permissions.Device_Update) && (!inGroup || device?.canEdit   === true);
  const canDelete = havePermission(Permissions.Device_Delete) && (!inGroup || device?.canDelete === true);

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose} sx={{ borderRadius: "35px" }}>
      {canEdit && (
        <MenuItem onClick={onView} sx={{ gap: "5px" }}>
          <EditOutlined />
          {"Cihaz Düzenle"}
        </MenuItem>
      )}
      {canDelete && onDelete && (
        <MenuItem onClick={onDelete} sx={{ gap: "5px", color: "error.main" }}>
          <DeleteOutline />
          {"Cihaz Sil"}
        </MenuItem>
      )}
    </Menu>
  );
};

export default DeviceMenu;
